module.exports = __webpack_public_path__ + "img/zt2-1.18cc076.png";